/**
 * Optional toolbar row below the global Header (e.g. action buttons).
 * Title, breadcrumb, and page description live in the main Header — not repeated here.
 */
export function PageHeader({ children, extra, actions }) {
  const toolbarExtra = extra ?? actions;
  const hasToolbar = Boolean(toolbarExtra);

  if (!hasToolbar && !children) {
    return null;
  }

  return (
    <div className="w-full min-w-0">
      {hasToolbar ? (
        <div data-slot="page-toolbar" className="mb-[var(--ds-space-5)] flex flex-wrap items-start justify-end gap-[var(--ds-space-2)]">
          {toolbarExtra}
        </div>
      ) : null}

      {children}
    </div>
  );
}
